module.exports = __webpack_public_path__ + "static/img/主图@2x (3).fd198f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/主图@2x (3).png
// module id = onPq
// module chunks = 1